











import { defineComponent, PropType, ref } from '@vue/composition-api'

import OutputConditionGroup from '@/components/organisms/h/outputCond/OutputConditionGroup.vue'
import {
  outputConditionGroupOutputCondition,
  outputCondUseInfoList,
  ItemOrderNumAdjOutputCondition,
} from '@/types/entities'
import {
  OUTPUT_EXTRACT_TARGET_DEFAULT,
  OUTPUT_EXTRACT_TARGET,
} from '@/utils/constant'

export default defineComponent({
  components: {
    OutputConditionGroup,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
  },
  setup(_, context) {
    const changeOutputCondition = (
      params: outputConditionGroupOutputCondition
    ) => {
      const cond: ItemOrderNumAdjOutputCondition = {
        extractTarget: params.extractTarget || OUTPUT_EXTRACT_TARGET_DEFAULT,
        delOutput: params.delOutput || [],
      }
      context.emit('change-output-condition', cond)
    }
    const TargetSelectVal = OUTPUT_EXTRACT_TARGET.specify
    return {
      changeOutputCondition,
      TargetSelectVal,
    }
  },
})
